import React from 'react';
import { connect } from 'react-redux';
import {Route} from 'react-router-dom';

import {fetchUserIdentityData } from '../../dataFetchers/noAuthDataFetcher';
import { Configuration } from "../../configs/Configuration";
import { parseQueryParams } from '../../helpers/URLHelper';
import {setUserHash} from '../../actions/userDataActions';
import { currentAuthToken } from '../../helpers/authHelper';
import { isAuthenticatedUsingSSO } from '../../actions/ssoActions';
import { bidgelyStorage } from '../../helpers/storageHelper';

import StandaloneContainer from '../../components/standalone/StandaloneContainer';
import BCLLoading from '../../components/common/Loading/BCLLoading';
import Unauthorized from '../../components/common/Error/Unauthorized/Unauthorized';

class StandAloneAuthenticationLayer extends React.Component{
    configuration = Configuration.getConfiguration();

    componentDidMount(){
        let options={
            "pilot-id" : this.configuration.pilotId,
            "client-id" : this.configuration.clientId
        }
        if(this.props.location.search !== ""){
           let parsedString = parseQueryParams(this.props.location.search);
           if (parsedString['user-hash']) {
            bidgelyStorage.setItem('userHash', parsedString['user-hash']);
           }
        }
        let userHash = bidgelyStorage.getItem('userHash');
        this.props.setUserHash(userHash);
        this.props.fetchUserIdentityData(userHash, options);

        if(bidgelyStorage.getItem('sso')){
            this.props.isAuthenticatedUsingSSO();
        }
    }

    render(){
        return(
            <div>
                {this.props.userHash.userHashExpired ?
                    <Unauthorized />
                :
                    (currentAuthToken !== null) && (this.props.userDetails  !== null) ? <Route component={StandaloneContainer}/> : <BCLLoading />
                }
            </div>
        )
    }
}

const mapStateToProps = state => {
    return{
        userDetails : state.userObject,
        userHash : state.userHash
    }
}

const mapDispatchToProps = dispatch => {
    return{
        setUserHash : (userHash) => dispatch(setUserHash(userHash)),
        fetchUserIdentityData : (userHash,options) => dispatch(fetchUserIdentityData(userHash,options)),
        isAuthenticatedUsingSSO: () => dispatch(isAuthenticatedUsingSSO())
    }
}

export default connect(mapStateToProps,mapDispatchToProps)(StandAloneAuthenticationLayer);
